<script lang="ts">
  /**
   * TickEdge stage backdrop.
   *
   * Renders the fixed full-viewport canvas: deep navy base, three radial-gradient
   * glow ellipses (blue + gold + purple), a subtle SVG film-grain overlay, and a
   * faint horizon glow line at the 60% Y line. Sits behind everything; floating
   * glass panels stack on top via their own z-index.
   */
</script>

<div class="stage" aria-hidden="true"></div>

<style>
  .stage {
    position: fixed;
    inset: 0;
    overflow: hidden;
    z-index: 0;
    background:
      radial-gradient(ellipse 1200px 700px at 18% 22%, rgba(91, 163, 255, 0.1) 0%, transparent 60%),
      radial-gradient(
        ellipse 1000px 800px at 88% 78%,
        rgba(224, 184, 106, 0.08) 0%,
        transparent 60%
      ),
      radial-gradient(
        ellipse 800px 600px at 50% 110%,
        rgba(169, 146, 255, 0.05) 0%,
        transparent 60%
      ),
      var(--bg-deep);
  }

  .stage::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='1.4' numOctaves='2'/><feColorMatrix type='matrix' values='0 0 0 0 1, 0 0 0 0 1, 0 0 0 0 1, 0 0 0 0.045 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>");
    mix-blend-mode: overlay;
    opacity: 0.6;
  }

  .stage::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background: linear-gradient(
      180deg,
      transparent 0%,
      transparent 56%,
      rgba(91, 163, 255, 0.06) 60%,
      transparent 64%,
      transparent 100%
    );
  }
</style>
